import ImageMarquee from "./ImageMarquee";

const ImageMarqueeWithProps = ({ blok }) => {
  return <ImageMarquee rowOne={blok.rowOne} rowTwo={blok.rowTwo} />;
};

export default ImageMarqueeWithProps;
